import React from 'react';
import './RecentOrdersPreview.css';

const STATUS_COLORS = {
  PENDING:          '#ffa500',
  CONFIRMED:        '#4169e1',
  PACKED:           '#9370db',
  SHIPPED:          '#20b2aa',
  OUT_FOR_DELIVERY: '#32cd32',
  DELIVERED:        '#28a745',
  CANCELLED:        '#dc3545',
};

const parseItems = (str) => { try { return JSON.parse(str || '[]'); } catch { return []; } };

function RecentOrdersPreview({ orders, onViewAll }) {
  return (
    <div className="dashboard-section recent-orders-section">
      <div className="section-header">
        <h3>Your Recent Orders</h3>
        <button className="btn-view-all" onClick={onViewAll}>View All Orders</button>
      </div>

      {!orders || orders.length === 0 ? (
        <div className="empty-orders">
          <p>You have no recent orders</p>
          <button className="btn-shop-now" onClick={onViewAll}>Start Shopping</button>
        </div>
      ) : (
        <div className="orders-preview-grid">
          {orders.map((order) => {
            const items = parseItems(order.items);
            const productNames = items.length > 0
              ? items[0].productName + (items.length > 1 ? ` +${items.length - 1} more` : '')
              : 'Order';
            return (
              <div key={order.id} className="order-preview-card" onClick={onViewAll}>
                <div className="order-preview-header">
                  <span className="order-id">#{order.id}</span>
                  <span className="order-status-badge" style={{ backgroundColor: STATUS_COLORS[order.status] || '#6c757d' }}>
                    {order.status}
                  </span>
                </div>
                <div className="order-product-name">{productNames}</div>
                <div className="order-preview-body">
                  <p className="order-date">
                    {new Date(order.createdAt).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' })}
                  </p>
                  <p className="order-amount">₹{Number(order.totalAmount).toLocaleString('en-IN', { minimumFractionDigits: 2 })}</p>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default RecentOrdersPreview;
